import React from "react";
import "../Styles/Footer.css";

function Footer() {
  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-brand">
          <strong>Windsor <span className="footer-accent">Precision Works</span></strong>
          <p>On-demand CNC machining for rapid prototyping and production parts. Serving industry for over 20 years.</p>
        </div>
        <div className="footer-links-col">
          <h4>Navigation</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/capabilities">Capabilities</a></li>
            <li><a href="/industries">Industries</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        <div className="footer-links-col">
          <h4>Contact</h4>
          <ul>
            <li>6240 Hawthorne Drive</li>
            <li>Windsor, ON N8T 1J9</li>
            <li>+1 519 800-8080</li>
            <li><a href="mailto:info@precisionworks.ca">info@precisionworks.ca</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Windsor Precision Works Inc. All rights reserved.</span>
        <span>
          <a href="/terms">Terms of Service</a>
          {" · "}
          <a href="/privacy">Privacy Policy</a>
          {" · "}
          <a href="/sitemap.xml">Sitemap</a>
        </span>
      </div>
    </footer>
  );
}

export default Footer;
